import { render, staticRenderFns } from "./Page2.vue?vue&type=template&id=4399a6c2&scoped=true"
import script from "./Page2.vue?vue&type=script&lang=js"
export * from "./Page2.vue?vue&type=script&lang=js"
import style0 from "./Page2.vue?vue&type=style&index=0&id=4399a6c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4399a6c2",
  null
  
)

export default component.exports